export enum ErrorCodes {
  USER_NOT_FOUND = 'USER_NOT_FOUND',
}

export interface ErrorDto {
  errorCode: string;
  message: string;
  statusCode: number;
}
